import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';
import AIAssistantIcon from '../../../../MyComponents/icons/AIAssistantIcon.js';
import Button from '@material-ui/core/Button';

const AiAssistantManagement = ({ language, classes, refs }) => {
    let instruments = [
        {
            id: 'redesign.page.tutorial.manageLesson.aiAssistant.explanation1',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='redesign.page.tutorial.manageLesson.aiAssistant.line0'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                        <Button
                            variant='outlined'
                            color='primary'
                            size='small'
                            startIcon={<AIAssistantIcon />}
                        >
                            <FormattedMessage id='menu.aiExercise' />
                        </Button>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='redesign.page.tutorial.manageLesson.aiAssistant.line1'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='redesign.page.tutorial.manageLesson.aiAssistant.line2'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='redesign.page.tutorial.manageLesson.aiAssistant.line3'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='redesign.page.tutorial.manageLesson.aiAssistant.line4'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='redesign.page.tutorial.manageLesson.aiAssistant.line5'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [`/static/asset/img/tutorial/withText/${language.toUpperCase()}/ai_assistant_open.jpg`],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLesson-aiAssistantManagement'}
            title={'redesign.page.tutorial.manageLesson.aiAssistantManagement.title'}
            explanations={instruments}
            imageTop={false}
        />
    );
};

export default AiAssistantManagement;
